export default __webpack_public_path__ + "static/cl-cs-impact-1e5ea2f623c8a63838ad67911fc39a60.jpg";